import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ResalesService = {
    list: async () => axios.get(API_URL + "/resales/list").then(({data}) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + "/resales/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (model) => axios.post(API_URL + "/resales", model).then(({data}) => data).catch((err) => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/resales/" + id, model).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/resales/" + id).then(({data}) => data).catch((err) => { throw err }),

    options: async () => axios.get(API_URL + "/resales/options").then(({data}) => data).catch((err) => { throw err }),
};

export default ResalesService;